
import * as defaultImport from "@loki/create-async-callback";
export * from "@loki/create-async-callback";
export default ('default' in defaultImport ? defaultImport.default : defaultImport);
